import React, { useState } from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function UserIdentityPreview({
  name,
  imageUrl,
  subtitle,
  imageSize,
  nameVariant,
  nameFontWeight,
  showText,
}) {
  const [open, setOpen] = useState(false);
  const displayName = String(name || "User").trim() || "User";
  const initial = displayName.charAt(0).toUpperCase();

  const triggerPreview = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    if (imageUrl) {
      setOpen(true);
    }
  };

  return (
    <>
      <MDBox display="flex" alignItems="center" gap={1.25}>
        {imageUrl ? (
          <MDBox
            component="img"
            src={imageUrl}
            alt={displayName}
            onClick={triggerPreview}
            sx={{
              width: imageSize,
              height: imageSize,
              borderRadius: "50%",
              objectFit: "cover",
              border: "2px solid rgba(24,53,38,0.08)",
              cursor: "zoom-in",
              flexShrink: 0,
            }}
          />
        ) : (
          <MDBox
            width={imageSize}
            height={imageSize}
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="50%"
            sx={{
              background:
                "linear-gradient(135deg, rgba(24,53,38,1) 0%, rgba(242,117,0,0.92) 100%)",
              color: "#ffffff",
              fontWeight: 700,
              cursor: "default",
              flexShrink: 0,
            }}
          >
            {initial}
          </MDBox>
        )}

        {showText ? (
          <MDBox>
            <MDTypography
              variant={nameVariant}
              fontWeight={nameFontWeight}
              sx={{
                color: "#ffffff",
                fontSize: "1rem",
                lineHeight: 1.2,
                letterSpacing: "0.01em",
              }}
            >
              {displayName}
            </MDTypography>
            {subtitle ? (
              <MDTypography variant="caption" display="block" sx={{ color: "#8fa7c4" }}>
                {subtitle}
              </MDTypography>
            ) : null}
          </MDBox>
        ) : null}
      </MDBox>

      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <DialogContent sx={{ p: 0, position: "relative", backgroundColor: "#08140d" }}>
          <IconButton
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              top: 12,
              right: 12,
              zIndex: 1,
              color: "#ffffff",
              backgroundColor: "rgba(0, 0, 0, 0.45)",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.62)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
          {imageUrl ? (
            <MDBox
              component="img"
              src={imageUrl}
              alt={displayName}
              sx={{
                display: "block",
                width: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
                backgroundColor: "#08140d",
              }}
            />
          ) : null}
        </DialogContent>
      </Dialog>
    </>
  );
}

UserIdentityPreview.defaultProps = {
  subtitle: "",
  imageUrl: "",
  imageSize: 44,
  nameVariant: "button",
  nameFontWeight: 700,
  showText: true,
};

UserIdentityPreview.propTypes = {
  name: PropTypes.string,
  imageUrl: PropTypes.string,
  subtitle: PropTypes.string,
  imageSize: PropTypes.number,
  nameVariant: PropTypes.string,
  nameFontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showText: PropTypes.bool,
};

export default UserIdentityPreview;
